module.exports = __webpack_public_path__ + "img/NivelSensor3D.065c8f47.png";